import React from 'react';
import Checkbox from '@mui/material/Checkbox';
import DefaultCheckbox from 'public/new-icons/default-checkbox.svg';
import CheckedCheckbox from 'public/new-icons/checked-checkbox.svg';

const CustomCheckbox = (props) => {
  return (
    <Checkbox
      icon={<DefaultCheckbox />}
      checkedIcon={<CheckedCheckbox />}
      {...props}
    />
  );
};

export default CustomCheckbox;
